import React from 'react'
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import SectionTitle from '../../elements/sectionTitle/SectionTitle';
import ContentVideo from './../../elements/video/ContentVideo';
import ContentPricing from '../../components/content/ContentPricing';
import ContentCallToAction from '../../components/content/ContentCallToAction';





const Content = () => {
    return (
        <>
            <SEO title="Content" />
            <main className="page-wrapper">
                {/* <HeaderTopBar /> */}
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                {/* <CommunityHero /> */}

                {/* Content Video Section Start */}
                <div className="rn-service-area rn-section-gap ">
                    <div className='container'>
                        <ContentVideo />
                    </div>
                </div>
                {/* Content Video Section End */}

                                    
                                    
                                    
                {/* Start Elements Area  Community Pricing*/}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = "CONTENT PRICING"
                                    // title = "Start Learning and Graw With Our Community"
                                    description = ""
                                />
                            </div>
                        </div>
                        <ContentPricing/>
                    </div>
                </div>
                {/* End Elements Area  */}

                {/* Start Elements Call To Action Area  */}
                <div className="rwt-callto-action-area rn-section-gapBottom">
                    <div className="wrapper">
                        <ContentCallToAction />
                    </div>
                </div>
                {/* End Elements Area  */}


                <FooterOne />
                <Copyright />
            </main>

        </>
    )
}

export default Content
